import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import LoginForm from './components/LoginForm'
import Dashboard from './components/Dashboard'
import Calendar from './components/Calendar'
import AdminPanel from './components/AdminPanel'
import Documentation from './components/Documentation'
import LoadingSpinner from './components/LoadingSpinner'

const App: React.FC = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/docs" element={<Documentation />} />
        <Route
          path="/login"
          element={
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="max-w-md w-full space-y-8">
                <div className="text-center">
                  <h1 className="text-3xl font-bold text-gray-900">
                    Shared Reservation Calendar
                  </h1>
                  <p className="mt-2 text-gray-600">
                    Sign in to manage your reservations
                  </p>
                </div>
                <LoginForm />
              </div>
            </div>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/docs" element={<Documentation />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/login" element={<Navigate to="/" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </React.Suspense>
  )
}

export default App 